<template>

<app-page>

	<core-content-page>

		<core-content-wrapper :loading="is.loading && !is.initialised">

			<div class="items" :class="{'is-hidden': is.loading && !is.initialised}">

				<div class="item is-intro" key="intro">

					<div class="item-text">

						<p>An <b>External Domain</b> is a domain you already own that you wish to point to your profile such as <i>yourdomain.com</i> or <i>subdomain.yourdomain.com</i>.</p>
                        
                        <p>This will not be a redirect but a fully working domain or subdomain that behaves as your profile. All it requires is for you to update your DNS to point to the geekgroup IP.</p>

                        <p>All external domains will be reviewed prior to being activated to ensure their DNS has been updated correctly and this may take up to 24 hours. You cannot change an external domain for at least 7 days.</p>

					</div>

				</div>

				<div class="item is-group is-unassigned" key="unassignedgroup" v-if="!data.user">

                    <h2>{{ username }}<small>Your profile</small></h2>

                    <div><i class="fa fa-user item-icon" /></div>

					<div class="item-actions">

                        <core-button theme="white" text="Setup domain" class="item-button" v-on:click="onUserClick" />

                    </div>

				</div>

                <template v-if="data.user">

				<div class="item is-group is-assigned" :class="{'is-building': !data.user.ready}" key="user">

                    <h2>{{ username }}<small>{{ data.user.value }}</small></h2>

                    <div v-if="data.user.ready"><i class="fa fa-users item-icon" /></div>
                    <div v-if="!data.user.ready"><i class="fa fa-cog fa-spin item-icon" /></div>

					<div class="item-actions" v-if="data.user.canRemove">

                        <core-button theme="whitegreen" text="Remove" v-on:click="onUserClick" />

                    </div>

					<p v-if="!data.user.canRemove && data.user.ready">Can change {{ data.user.removeDate | fromNow }}.</p>
					<p v-if="!data.user.canRemove && !data.user.ready">Awaiting approval...<small>This may take up to 24 hours.</small></p>

					<div class="item-actions" v-if="data.user.canCancel">

                        <core-button theme="whiteyellow" text="Manage" v-on:click="onUserClick" />

                    </div>

				</div>

                </template>

				<div class="item is-group is-locked" key="lockedgroup" v-if="!data.canGroup">

                    <h2>Group</h2>

                    <div><i class="fa fa-lock item-icon" /></div>

					<div class="item-actions">

                        <core-button href="https://patreon.com/geekgroup" text="Go to Patreon" class="item-button" />

                    </div>

				</div>

				<div class="item is-group is-unassigned" key="unassignedgroup" v-if="data.canGroup && !data.group">

                    <h2>Group</h2>

                    <div><i class="fa fa-users item-icon" /></div>

					<div class="item-actions">

                        <core-button theme="white" text="Choose group" class="item-button" v-on:click="onChooseClick" />

                    </div>

				</div>

                <template v-if="data.group">

				<div class="item is-group is-assigned" :class="{'is-building': !data.group.ready}" key="group" v-if="data.canGroup">

                    <h2>{{ groupName }}<small>{{ data.group.value }}</small></h2>

                    <div v-if="data.group.ready"><i class="fa fa-users item-icon" /></div>
                    <div v-if="!data.group.ready"><i class="fa fa-cog fa-spin item-icon" /></div>

					<div class="item-actions" v-if="data.group.canRemove">

                        <core-button theme="whitegreen" text="Remove" v-on:click="onGroupClick" />

                    </div>

					<p v-if="!data.group.canRemove && data.group.ready">Can change {{ data.group.removeDate | fromNow }}.</p>
					<p v-if="!data.group.canRemove && !data.group.ready">Awaiting approval...<small>This may take up to 24 hours.</small></p>

                    <div class="item-actions" v-if="data.group.canCancel">

                        <core-button theme="whiteyellow" text="Manage" v-on:click="onGroupClick" />

                    </div>

				</div>

                </template>

			</div>

		</core-content-wrapper>

	</core-content-page>
		
</app-page>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {
	
		return {

			data: {},

			is: {
				initialised: false,
				loading: true
			},

			timer: false

		}
	
	},

	created: function() {

		this.load()
	
		this.$pubsub.$on('session.patreon.externaldomains', this.reload.bind(this))

	},

	beforeDestroy: function() {

		this.$pubsub.$off('session.patreon.externaldomains', this.reload.bind(this))

		clearTimeout(this.timer)

	},

	computed: {

		username: function() {

			return this.$store.getters['session'].name 

		},

		groupName: function() {

			return this.$_.findWhere(this.$store.getters['session/groups'], {
				id: this.data.group.recipient
			}).name

		}

	},

	methods: {
	
		load: function() {
		
			this.is.loading = true

			this.$api.get('session/externaldomains').then(function(json) {

				Vue.set(this, 'data', json)

				this.is.initialised = true

				this.is.loading = false

				if (!json.ready && json.group) {

					this.timer = this.$_.delay(function() {

						this.load()

					}.bind(this), 300000)

				}
			
			}.bind(this))
		
		},
	
		reload: function() {
		
			this.is.initialised = false

			this.load()
		
		},

        onUserClick: function() {

			this.$pubsub.$emit('open.modal', 'sessionPatreonExternaldomainsUser')

        },

		onChooseClick: function() {

			this.$pubsub.$emit('open.modal', 'sessionPatreonExternaldomainsGroup')

		},

		onGroupClick: function() {

			this.$pubsub.$emit('open.modal', 'sessionPatreonExternaldomainsGroup')

		}

	}

}

</script>

<style scoped>

.items {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-rows: auto;
	grid-gap: 40px;
}

.is-smaller .items {
	grid-gap: 20px;
}

.is-tablet .items {
	grid-gap: 20px;
	grid-template-columns: 1fr 1fr;
}

.is-mobile .items {
	grid-template-columns: 1fr;
	grid-gap: 20px;
}

.items.is-hidden {
	opacity: 0;
}

.item {
	background-color: #fff;
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 20px;
    min-height: 320px;
}

.is-mobile .item.is-intro {
	min-height: auto;
}

.item-image {
	height: 180px;
	background-size: contain;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-color: #4881bb;
	border-radius: 4px 4px 0px 0px;
}

.item.is-intro .item-text {
	height: 100%;
}

.item-text p {
	font-size: 16px;
	line-height: 20px;
	color: #222;
	margin-bottom: 20px;
}

.item-text p i {
	font-style: italic;
}

.item-text p:last-child {
	margin-bottom: 0px;
}

.item-date {
	font-size: 14px;
	line-height: 14px;
	font-weight: 400;
	color: #999;
	margin-bottom: 10px;
}

.item-button {
	width: 100%;
}

.item.is-user,
.item.is-group {
    text-align: center;
    display: grid;
    grid-template-rows: auto 1fr auto;
}

.item.is-assigned,
.item.is-user {
    background-color: #48bb6d;
    color: #fff;
}

.item.is-building {
    background-color: #de8635;
    color: #fff;
}

.item.is-unassigned {
    background-color: #bb4848;
    color: #fff;
}

.item h2 {
    font-size: 24px;
    font-weight: 500;
}

.item h2 small{
    font-size: 16px;
	display: block;
    font-weight: 300;
	margin-top: 4px;
}

.item-icon {
    font-size: 128px;
    position: absolute;
    top: 50%;
    left: 50%;
	width: 200px;
	height: 128px;
	margin-left: -100px;
	margin-top: -64px;
}

.is-mobile .item-icon {
	font-size: 96px;
	margin-top: -48px;
	height: 96px;
}

.item.is-locked .item-icon {
    color: #ccc;
}

.item.is-group p,
.item.is-user p {
    font-size: 16px;
	line-height: 20px;
	padding: 10px 0px;
    font-weight: 400;
}

.item.is-group p small {
	font-size: 14px;
	display: block;
	opacity: 0.75;
}

.item-actions {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr;
}

.item-subtext {
	font-weight: 400;
	font-size: 14px;
}

</style>